import React, { Component } from "react";
import StepWizard from "react-step-wizard";
//// componentes reutilizables
import Titulo from "../../../generico/TituloPagina";
import Paso1 from "./SolidaridadPaso1";
import Paso2 from "./SolidaridadPaso2";
import Paso3 from "./SolidaridadPaso3";

export default class PagoSolidaridad extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.paso1 = React.createRef();
    this.paso2 = React.createRef();
    this.paso3 = React.createRef();
  }

  resetState = () => {
    this.setState(this.getInitialState());
  };

  getInitialState = () => ({
    cuentaOrigen: {},
    ctaFullData: {},
    importe: "0",
    moneda: "",
    nroOperacion: "",
  });

  returnDataPaso1(_importe, _ctaFullData, _moneda) {
    this.setState({
      importe: _importe,
      ctaFullData: _ctaFullData,
      moneda: _moneda,
    });
  }

  returnDataPaso2(_nroOperacion) {
    this.setState({
      nroOperacion: _nroOperacion,
    });
  }

  returnDataPaso3() {
    this.initDataChildren();
  }

  initDataChildren() {
    this.paso1.current.initData();
    this.paso2.current.resetState();
  }

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Pago de Solidaridad" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <StepWizard transitions="none">
                    <Paso1
                        ref={this.paso1}                        
                        returnDataPaso1={this.returnDataPaso1.bind(this)}
                      />
                      <Paso2
                        ref={this.paso2}
                        ctaFullData ={this.state.ctaFullData}
                        importe = {this.state.importe}
                        moneda = {this.state.moneda}
                        returnDataPaso2={this.returnDataPaso2.bind(this)}
                      />
                      <Paso3
                        ref={this.paso3}
                        ctaFullData ={this.state.ctaFullData}
                        importe = {this.state.importe}
                        moneda = {this.state.moneda}
                        nroOperacion = {this.state.nroOperacion}
                        returnDataPaso3={this.returnDataPaso3.bind(this)}
                      />
                    </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
